<template>
  <main class="container solution-total">
    <section ref="sectionRef" class="wellcome-section">
      <button class="btn outline">
        Integrated Pest Management Solution <br class="mo_show" />
        (IPM Solution)
      </button>

      <h2>
        The Golden Window for <br class="pc_show" />
        Preventing <br class="mo_show" />
        Pest Proliferation
      </h2>

      <p>
        The discovery of a single pest could mean that tens of thousands are already infesting various parts of your property. Partner with a CESCO
        consultant to prevent them from multiplying into hundreds of millions.
      </p>

      <a ref="buttonRef" id="applyButton" :class="[buttonClass, buttonHiddenClass]" href="mailto:'sj.kim@cesco.co.kr'"> Send Email </a>
    </section>

    <img :src="require(`@/assets/images/solution/total/main${mobileCheck ? '_mo' : ''}.png`)" class="main-img" alt="" />

    <section class="section">
      <div class="contents-center">
        <h3 class="title-section">Do pests really breed this extensively?</h3>
        <p class="description-section">
          Did you think it was just ‘a pest’?
          <br />
          Being complacent is dangerous with pests that have high fertility and resilience.
        </p>

        <div class="list-item">
          <div class="item">
            <div>
              <p class="label">A pair of cockroach can reproduce</p>
              <h4>Up to 200 million offspring</h4>
              <p class="discription">Up to 200 million in a year</p>
            </div>

            <div class="image">
              <img src="@/assets/images/solution/total/list_01.svg" alt="" />
            </div>
          </div>

          <div class="item">
            <div>
              <p class="label">A single colony of ants means</p>
              <h4>Up to 2.5 million ants</h4>
              <p class="discription">
                Thrives nearly everywhere on Earth, except Polar regions, with a lifespan of about 30 years and notable survival capabilities
              </p>
            </div>

            <div class="image">
              <img src="@/assets/images/solution/total/list_02.svg" alt="" />
            </div>
          </div>

          <div class="item">
            <div>
              <p class="label">
                A pair of rats can <br class="pc_show" />
                produce
              </p>
              <h4>Up to 1,200 offspring</h4>
              <p class="discription">
                Manage up to 8 pregnancies per <br class="mo_show" />
                year, potentially producing up to <br class="mo_show" />
                1,200 offspring
              </p>
            </div>

            <div class="image">
              <img src="@/assets/images/solution/total/list_03.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section tab-area">
      <div class="contents-center">
        <div class="tab-info">
          <h3 class="title-section">Where exactly are the problem pests invading from?</h3>
          <p class="description-section">
            Problem pests enter through delivery boxes, furniture, and other shipments, utilizing various <br class="pc_show" />
            pathways including drains, air conditioning outdoor unit piping, <br class="pc_show" />
            and inter-floor movements within buildings
          </p>
        </div>

        <div class="tabs">
          <button
            v-for="item in tabList"
            :key="`tab-${item.id}`"
            :id="`tab-${item.id}`"
            :class="['tab-button', tab === item.id && 'active']"
            @click="handleTabClick(item.id)"
          >
            {{ item.name }}
          </button>
        </div>
        <button class="btn-list">Press the button to check.</button>
      </div>

      <div v-if="!mobileCheck" class="tab-contents">
        <div v-if="tab === 0" class="tab-content">
          <swiper
            :slides-per-view="'auto'"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="total-swiper"
          >
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_01.png" alt="" />
              <div class="h-78 centered-content">
                <p>Entry points include kitchen plumbing and trenches where pests emerge</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_02.png" alt="" />
              <div class="h-78 centered-content">
                <p style="letter-spacing: -0.038rem">Plants serve as entry and residing points</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_03.png" alt="" />
              <div class="h-78 centered-content">
                <p style="letter-spacing: -0.038rem">Air conditioning outdoor unit piping</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_04.png" alt="" />
              <div class="h-78 centered-content">
                <p>Kitchen and balcony drains</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_05.png" alt="" />
              <div class="h-78 centered-content">
                <p>Wooden furniture and other items are pathways for pest entry</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_06.png" alt="" />
              <div class="h-78 centered-content">
                <div class="h-78 centered-content">
                  <p>
                    Pests move through inter-floor <br />
                    spaces, balconies, and windows <br />
                    within the same building
                  </p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_07.png" alt="" />
              <div class="h-78 centered-content">
                <p>Bathroom sewage pipes are entry points for pests</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_08.png" alt="" />
              <div class="h-78 centered-content">
                <p>External delivery boxes and items bring in pests</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_09.png" alt="" />
              <div class="h-78 centered-content">
                <p>Outer pipes are conduits for pest entry</p>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div v-if="tab === 1" class="tab-content">
          <swiper
            :slides-per-view="'auto'"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="total-swiper"
          >
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_01.png" alt="" />
              <div class="h-78 centered-content">
                <p>Daily incoming food supplies introduce pests</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab02_02.png" alt="" />
              <div class="h-78 centered-content">
                <p>Clothing and bags carry pests when people enter</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_03.png" alt="" />
              <div class="h-78 centered-content">
                <p style="letter-spacing: -0.038rem">Air conditioning piping facilitates pest entry</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_01.png" alt="" />
              <div class="h-78 centered-content">
                <p>Entry points include kitchen plumbing and trenches where pests emerge</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab02_05.png" alt="" />
              <div class="h-78 centered-content">
                <p>Entrances serve as gateways for pests</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab02_06.png" alt="" />
              <div class="h-78 centered-content">
                <p>Garbage areas are frequent sources of pest emergence and introduction</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_07.png" alt="" />
              <div class="h-78 centered-content">
                <p>Bathroom sewage pipes are entry points for pests</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_09.png" alt="" />
              <div class="h-78 centered-content">
                <p>Outer pipes are conduits for pest entry</p>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div v-if="tab === 2" class="tab-content">
          <swiper
            :slides-per-view="'auto'"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="total-swiper"
          >
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_09.png" alt="" />
              <div class="h-78 centered-content">
                <p>Boiler rooms are common sites for pest emergence and habitation</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab02_06.png" alt="" />
              <div class="h-78 centered-content">
                <p>Garbage areas are frequent sources of pest emergence and introduction</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_07.png" alt="" />
              <div class="h-78 centered-content">
                <p>Bathroom sewage pipes are entry points for pests</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab02_05.png" alt="" />
              <div class="h-78 centered-content">
                <p>Entrances serve as gateways for pests</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab03_05.png" alt="" />
              <div class="h-78 centered-content">
                <p>Vents and windows allow pests to enter</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_01.png" alt="" />
              <div class="h-78 centered-content">
                <p>Entry points include kitchen plumbing and trenches where pests emerge</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab02_02.png" alt="" />
              <div class="h-78 centered-content">
                <p>Clothing and bags carry pests when people enter</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab03_08.png" alt="" />
              <div class="h-78 centered-content">
                <p>Office furniture and equipment deliveries can introduce pests</p>
              </div>
            </swiper-slide>
            <swiper-slide class="card">
              <img src="@/assets/images/solution/total/tab01_06.png" alt="" />
              <div class="h-78 centered-content">
                <p>Box packaging materials are vehicles for pest entry</p>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section class="section pest-reappearance">
      <div class="contents-center">
        <div class="pest-reappearance-info">
          <h3 class="title-section">Why do pests reappear after extermination?</h3>
          <p class="description-section">
            Even if pests are temporarily eradicated,<br />
            maintaining the same environment<br />
            results in an 80% chance of pest recurrence<br />
            within three months.
          </p>
        </div>

        <div class="pest-reappearance-causes">
          <div class="cause-item">
            <img src="@/assets/images/icons/checked.svg" alt="" />
            <div>
              <p class="label">Used without accurate diagnoses by general pest control companies</p>
              <h4 class="title">Resistance due to indiscriminate chemical usage</h4>
            </div>
          </div>

          <div class="cause-item">
            <img src="@/assets/images/icons/checked.svg" alt="" />
            <div>
              <p class="label">The customer's environment and the pest's habitat</p>
              <h4 class="title">Chemicals distributed without analyzing</h4>
            </div>
          </div>

          <div class="cause-item">
            <img src="@/assets/images/icons/checked.svg" alt="" />
            <div>
              <p class="label">After pest extermination and control</p>
              <h4 class="title">Environments remain neither supplemented nor improved</h4>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section cesco-benefits">
      <div class="contents-center">
        <div class="cesco-benefits-info">
          <h3 class="title-section">Why does everyone choose CESCO eventually?</h3>

          <p class="description-section">CESCO offers a ‘personalized pest control service’ that takes into account your property.</p>
        </div>

        <div class="cesco-benefits-list">
          <div class="benefit-item">
            <div class="benefit-icon">
              <p class="number">01</p>
              <img class="icon" src="@/assets/images/solution/total/benefit_01.svg" alt="" />
            </div>
            <div>
              <h4 class="title">
                The most effective <br />
                medications for <br class="mo_show" />
                pests
              </h4>
              <p>
                We have studied 731 pest species in order to develop pest-specific formulations that cannot be matched by low-cost imported
                formulations.
              </p>
            </div>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon">
              <p class="number">02</p>
              <img class="icon" src="@/assets/images/solution/total/benefit_02.svg" alt="" />
            </div>
            <div>
              <h4 class="title">
                Luring pests with <br />
                300 new flavors <br class="mo_show" />
                without resistance!
              </h4>
              <p>Uses 300 different medications made from over 1,000 self-developed recipes, rotated every three months to prevent resistance.</p>
            </div>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon">
              <p class="number">03</p>
              <img class="icon" src="@/assets/images/solution/total/benefit_03.svg" alt="" />
            </div>
            <div>
              <h4 class="title">
                Target pests <br />
                exclusively, eliminating
                <br />
                other concerns
              </h4>
              <p>Formulated based on toxicity components and lethal dose studies, deadly to pests only.</p>
            </div>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon">
              <p class="number">04</p>
              <img class="icon" src="@/assets/images/solution/total/benefit_04.svg" alt="" />
            </div>
            <div>
              <h4 class="title">
                Over 50 years of <br />
                industry-leading <br class="mo_show" />
                expertise unique to CESCO
              </h4>
              <p>A full-time employee, trained for 1,000 hours in 2,193 secret pest control techniques, delivers personalized control solutions.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section cesco-mark-section">
      <div class="contents-center">
        <div class="cesco-card">
          <div class="header">
            <h4 class="title">
              The CESCO <br />
              Members' Mark
            </h4>
            <p class="description">
              For businesses, we offer a <br class="mo_show" />
              certification mark to help customers recognize the space as pest-free and hygienic.
            </p>
          </div>
          <div class="card-image">
            <img src="@/assets/images/solution/total/members_mark.png" alt="" />
          </div>
        </div>
        <div class="cesco-card">
          <div class="header">
            <h4 class="title">Improve the safety of everyday spaces</h4>
            <p class="description">
              CESCO manages not only problem pests but also viruses, air quality, and water quality, ensuring optimal environments for each space.
            </p>
          </div>

          <swiper
            :slides-per-view="'auto'"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :spaceBetween="8"
            :breakpoints="{
              768: {
                spaceBetween: 20
              }
            }"
            :modules="[Autoplay]"
            class="cesco-swiper"
          >
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_01.png" alt="" />
              <p class="cesco-slide-title">Homes</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_02.png" alt="" />
              <p class="cesco-slide-title">Dining Establishments</p>
            </swiper-slide>

            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_03.png" alt="" />
              <p class="cesco-slide-title">Distribution Facilities</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_04.png" alt="" />
              <p class="cesco-slide-title">Educational Facilities</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_05.png" alt="" />
              <p class="cesco-slide-title">Building</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_06.png" alt="" />
              <p class="cesco-slide-title">Service Facilities</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_07.png" alt="" />
              <p class="cesco-slide-title">Cultural Facilities</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_08.png" alt="" />
              <p class="cesco-slide-title">Medical Facilities</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_09.png" alt="" />
              <p class="cesco-slide-title">Deluxe Hotels/ Resorts</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_10.png" alt="" />
              <p class="cesco-slide-title">
                Motels/
                <br />
                General Hotels
              </p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_11.png" alt="" />
              <p class="cesco-slide-title">Food Manufacturing</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_12.png" alt="" />
              <p class="cesco-slide-title">Manufacturing Plant</p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/total/cesco_swiper_13.png" alt="" />
              <p class="cesco-slide-title">Warehouse Facilities</p>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section ref="checkSectionRef" class="sub-footer">
      <h2>
        The Golden Window <br class="mo_show" />
        for Preventing <br />
        Pest Proliferation
      </h2>

      <p>Timely intervention is crucial for effective pest control.</p>

      <a class="btn" href="mailto:'sj.kim@cesco.co.kr'"> Send Email </a>
    </section>
  </main>

  <ModalView v-if="mobileCheck" :modal-state="modalState" @close-modal="closeModal">
    <TotalModalContent :tab="tab" :text="tabList[tab].name" />
  </ModalView>
</template>

<script setup>
import { inject } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import { useScroll, useModal, useTab } from '@/hooks'
import ModalView from '@/components/common/ModalView.vue'
import TotalModalContent from '@/components/modal/TotalModalContent.vue'

const { sectionRef, checkSectionRef, buttonRef, buttonClass, buttonHiddenClass } = useScroll()
const { modalState, openModal, closeModal } = useModal()
const { tab, handleTabClick } = useTab(openModal)

const mobileCheck = inject('mobileCheck')

const tabList = [
  { id: 0, name: 'Homes' },
  { id: 1, name: 'Food Service Establishments' },
  { id: 2, name: 'General Businesses' }
]
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/total.scss';
</style>
